"use client";

import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { useAppStore } from "@/client/store/appStore";

type AppThemeProviderProps = PropsWithChildren<{
  mode?: "light" | "dark";
}>;

const AppThemeProvider: React.FC<AppThemeProviderProps> = ({ children, mode }) => {
  const storeMode = useAppStore((state) => state.themeMode);
  const effectiveMode = mode ?? storeMode ?? "light";

  // 同步 data-theme，用于自定义样式读取
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("data-theme", effectiveMode);
    }
  }, [effectiveMode]);

  return (
    <NextThemesProvider attribute="class" forcedTheme={effectiveMode} defaultTheme="light" enableSystem>
      {children}
    </NextThemesProvider>
  );
};

export default AppThemeProvider;
